<template>
  <div class="form-group">
    <label for="groupPrefixField">Group Prefix</label>
    <small class="text-muted"> *Required. Start typing for suggestions</small>
    <div class="row">
      <div class="col-md-5 col-lg-4">
        <input
          type="text"
          class="form-control mb-2"
          id="groupPrefixField"
          placeholder="Start typing for suggestions"
          autocomplete="off"
          v-model.trim="search"
          ref="searchInput"
          @change="updatePrefix($event.target.value)"
          @input="onChange"
          @keydown.down="onArrowDown"
          @keydown.up="onArrowUp"
          @keydown.enter="onEnter"
          @focus="onFocus"
          @blur="onBlur">
        <ul id="ddl-prefix-list" class="list-group autocomplete-results" ref="scrollContainer" v-show="isOpen">
          <li ref="options"
              class=" list-group-item autocomplete-result"
              @mousedown.left="setResult(result)"
              v-for="(result, i) in results"
              :key = "result"
              :class="{ 'is-active': i === arrowCounter }"
              :id="'lst-prefix-'+result">
            {{ result }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupPrefix',
  props: {
    v: { type: Object },
    value: {
      type: String,
      default: '',
    },
    groupPrefixSuggestions: {
      type: Array,
      required: false,
      default: () => [],
    },
    stem: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: false,
      results: [],
      arrowCounter: 0,
      search: this.stem,
    };
  },
  mounted() {
    if (this.search !== null && this.search !== '') {
      this.prefixSet();
    }
  },
  methods: {
    prefixSet() {
      this.$emit('groupPrefixSelected', this.search.toLowerCase());
    },
    onFocus() {
      if (this.isOpen) {
        return;
      }
      this.isOpen = true;
      this.results = this.groupPrefixSuggestions;

      this.$nextTick(() => {
        this.fixScrolling();
      });
    },
    onBlur() {
      this.isOpen = false;
    },
    onChange() {
      // Let's search our flat array
      if (this.search !== null && this.search !== '') {
        this.filterResults();
        this.isOpen = true;
      } else {
        this.isOpen = false;
      }
    },
    filterResults() {
      // first uncapitalize all the things
      this.results = this.groupPrefixSuggestions
        .filter(item => item.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
    },
    setResult(result) {
      this.isOpen = false;
      this.search = result;
      this.arrowCounter = 0;
      this.prefixSet();
    },
    onArrowDown(event) {
      event.preventDefault();
      if (this.arrowCounter < this.results.length - 1) {
        this.arrowCounter = this.arrowCounter + 1;
        this.fixScrolling();
      }
    },
    onArrowUp(event) {
      event.preventDefault();
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
        this.fixScrolling();
      }
    },
    onEnter() {
      this.isOpen = false;
      this.search = this.results[this.arrowCounter];
      this.prefixSet();
      this.arrowCounter = 0;
      this.$refs.searchInput.blur();
    },
    updatePrefix() {
      this.prefixSet();
      this.v.$touch();
    },
    fixScrolling() {
      this.$refs.scrollContainer.children[this.arrowCounter].scrollIntoView({
        block: 'nearest',
      });
    },
  },
};
</script>

<style>
  .autocomplete-result {
    cursor: pointer;
  }

  .autocomplete-results {
    margin-bottom: 1rem;
    z-index: 1;
    word-wrap: break-word;
    height: auto;
    max-height: 200px;
    overflow-x: hidden;
    position: absolute;
    width: 95%;
    min-width: inherit;
  }

  .autocomplete-result.is-active:hover,
  .autocomplete-result.is-active {
    background-color: #0063cc;
    color: white;
  }

  .autocomplete-result:hover {
    background-color: #7f7f7f;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/GroupPrefix.vue